




import mixins from 'vue-typed-mixins';
export default mixins().extend({});
